<template>
  <transition name="fade">
    <div key="1" v-if="!$store.state.show.app" style="height: 100vh; width: 100vw"
      class="flex column label loading center">
      <img v-if="$store.state.app.basics.logo" style="height: 10vh; width: 10vh" :src="$store.state.app.basics.logo"
        alt="" />
      <span style="max-width: 80vw; overflow-wrap: anywhere" class="flex column center center-text">
        <code v-if="siteLoading.length > 144">
          {{ $store.state.app.basics["app name"] || domainCheck || "XMBL" }}
          may be offline. Please refresh or wait until the connection is
          re-established.
          <button
            class="xs-font t32 fill update-border update-text"
            @click="reload()"
          >
            Reload
          </button>
        </code>
        <div
          style="color: #fefffe; background: #000100; height: 100vh; width: 100vw; position: absolute; top: 0; left: 0;"
          v-else class="flex md-font">
          {{
            "Xmbling " +
            ($store.state.app.basics["app name"] || domainCheck || "XMBL")
          }}
          <span class="xs-font"> {{ siteLoading }}</span>
        </div>
      </span>
    </div>
    <div class="fill-h container p32" v-else-if="$store.state.devmode">
      <h1>Dev Mode</h1>
      <function></function>
      <state></state>
    </div>
    <div key="5" style="height: 100vh" v-else-if="maintenance.maintain && maintenance.maintain.brb"
      class="flexw xl-font center flex column">
      <!-- This is the beginning of decentralized data privacy -->
      <div style="
          height: 66%;
          width: 50%;
          min-width: 270px;
          max-width: 540px;
          text-align: center;
        " class="p16 flex center column glow">
        <b class="p8">{{ $store.state.app.basics["app name"] || domainCheck }} is on work
          holiday.</b>
        <code class="md-font p8">{{ maintenance.maintain.message }}</code>
        <button v-if="maintenance.reload" type="button" @click="reload()">
          Try Again
        </button>
        <img style="width: 80%; object-fit: contain" class="p16" src="/img/icons/favicon-128.png" alt="maintenance" />
      </div>
    </div>

    <div key="2 + $store.state.componentKeys.auth" v-on:keyup.esc="$store.commit('closeAll', { only: [], except: [] })"
      id="app" style="
        height: 100vh;
        width: 100%;
        overflow: scroll;
        -webkit-overflow-scrolling: touch;
        overflow-behavior: none;
      " v-else-if="
        $store.state.app &&
        $store.state.app.basics &&
        $store.state.app.basics.database === domainCheck &&
        (($store.state.app.basics && $store.state.app.basics.live) ||
          ($store.state.app.user &&
            $store.state.app.user.indexOf($store.state.auth.uid) > -1))
      ">
      <layout :id="`layout_${$store.state.app.basics.database}`">
        <template #header>
          <inav :key="'home_menu' + $store.state.counter" id="home_menu"
            :class="`home_menu_${$store.state.app.basics.database}`" :nohide="$store.state.app.basics.menus &&
              $store.state.app.basics.menus['home'] &&
              $store.state.app.basics.menus['home'].nohide
              " v-if="$store.state.app.basics.menus" style="width: 100%" name="home" />
        </template>
        <template #content>
          <main ref="main" id="main">
            <transition name="fade">
              <div>
                <router-view :class="'fill main_' +
                  ($route.params.iitemid ||
                    $route.params.pagetitle ||
                    $route.params.pagetitle ||
                    $route.name)
                  " :key="$route.fullPath"></router-view>
              </div>
            </transition>
            <ipage v-if="
              $store.state.app.pages.footer &&
              $store.state.app.pages.footer.published
            " pagetitle="footer" />
          </main>
        </template>
        <template #footer>
          <div class="flex align-center justify-start z10 p8" style="position: absolute; bottom: 0">
            <foot style="width: 100%" class="flex align-center sm-font"></foot>
          </div>
        </template>
      </layout>
      <div v-if="$store.state.show.secretBox" class="active-input sm-font" style="
          position: fixed;
          bottom: 38px;
          right: 4px;
          max-height: 81vh;
          overflow-y: scroll;
          min-width: 180px;
          border: 1px rgba(255, 255, 255, 0.4) solid;
          z-index: 99999;
        ">
        <div class="secret-info center" v-if="$store.state.secretCode.length > 19">
          <code>Your secret code.. touch it to copy and then send to others.</code>
          <h1 @click="
            $copyText($store.state.secretCode);
          verify = true;
          ">
            {{ $store.state.secretCode }}
          </h1>
          <h2 v-if="verify">Code copied to clipboard!</h2>
        </div>
        <div v-if="$store.state.secretEvent" class="secret-info flex center stretch between wrap">
          <img :src="$store.state.secretEvent.image" style="
              max-width: 50%;
              min-width: 120px;
              max-height: auto;
              object-fit: cover;
              flex: 1 1 50%;
            " />
          <div style="flex: 2 1 50%">
            <h2>{{ $store.state.secretEvent.title }}</h2>
            <p>WHEN: {{ $store.state.secretEvent.datetime }}</p>
            <p>WHERE: {{ $store.state.secretEvent.location }}</p>
            <p>WHY: {{ $store.state.secretEvent.desc }}</p>
            <p v-linkified>HOW: {{ $store.state.secretEvent.tickets }}</p>
            <button type="button" @click="
              $store.state.secretEvent = false;
            secretCode = '';
            ">
              <i class="fa fa-times"></i> Close
            </button>
          </div>
        </div>
        <label v-if="secretCode.length === 20" @click="
          checkSecret(secretCode);
        $store.state.secretEvent;
        " class="input-icon-search fa fa-search fa-xs"></label>
        <input v-model="secretCode" id="secret-code" class="input-with-icon sm-font" type="text"
          placeholder="Secret code?" />
      </div>
      <transition name="drop">
        <div v-if="$store.state.show.jobs || $store.state.show.events" class="module-popdown container">
          <code v-if="
            $store.state.show.cart &&
            !(
              $store.state.user[$store.state.auth.uid].cart ||
              $store.state.anon.cart
            )
          " class="container">Nothing in cart</code>
          <jobs :key="$store.state.componentKeys.jobs" class="sub-container flexw" v-if="
            ($store.state.related.jobs || $store.state.anon.jobs) &&
            $store.state.show.jobs
          "></jobs>
          <code v-else-if="
            $store.state.show.jobs &&
            !($store.state.related.jobs || $store.state.anon.jobs)
          " class="container">Nothing in jobs</code>
          <events :key="$store.state.componentKeys.events" class="sub-container flexw" v-if="
            ($store.state.related.events || $store.state.anon.events) &&
            $store.state.show.events
          "></events>
          <code v-else-if="
            $store.state.show.events &&
            !($store.state.related.events || $store.state.anon.events)
          " class="container">Nothing in events</code>
        </div>
      </transition>

      <transition name="drop">
        <div v-if="$store.state.show.messages" class="com-popdown">
          <message :key="6" class="container" style="overflow: scroll"></message>
        </div>
      </transition>

      <transition name="drop">
        <div v-if="$store.state.show.notifications" class="com-popdown">
          <notifications :key="7" class="sub-container" style="overflow: scroll"></notifications>
        </div>
      </transition>

      <div class="auth-modal" v-if="$store.state.show.auth">
        <div>
          <div class="flex column container" style="min-width: 260px">
            <div class="flex between p8 align-center">
              <code class="xs-font">
          <b>Authentication</b>
        </code>
              <i @click="$set($store.state.show, 'auth', false)" class="fa fa-times fa-lg"></i>
            </div>
            <login></login>
          </div>
        </div>
      </div>
      <pointer :id="Object.keys($store.state.pointer).length" :key="Object.keys($store.state.pointer).length"></pointer>
    </div>

    <div key="3" class="flex column wrap center" v-else-if="
      $store.state.app &&
      $store.state.app.basics &&
      $store.state.app.basics.database === 'fresh'
    " style="height: 100vh; overflow-y: scroll">
      <div style="position: relative" class="container">
        <div class="flex align-center gui-container" style="
            background: rgba(255, 255, 255, 0.9);
            color: black;
            position: fixed;
            top: 4px;
            right: 4px;
            z-index: 99999;
          ">
          <b>{{ domainCheck }}</b>
          <span class="sm-font l4 success-text">[ Unclaimed ]</span>
          <i v-if="$store.state.auth.uid" class="fas fa-unlock p4"
            @click="$store.dispatch('auth', { type: 'logout' })"></i>
        </div>
      </div>
      <div class="flex around wrap" style="overflow: scroll; -webkit-overflow-scrolling: touch">
        <div class="align-center flex m32 container">
          <div class="flex column p32" style="min-width: 270px; max-width: 420px" v-if="!$store.state.auth.uid">
            <div class="">

              <div class="flex b16 align-center">
                <img src="/img/icons/favicon-32x32.png" alt class="r16" />
                <div class="column flex">
                  <b class="md-font">XMBL Software Platform <span class="indicate-text xs-font ">
                      [ BETA ]
                    </span></b>
                  <i class="update-text sm-font">Full-stack as a service. Powerful, flexible, basically free</i>
                </div>
              </div>
              <h3 class="update-text bolder">Create app on {{ domainCheck }}</h3>
              <p>XMBL applications with custom functions, event hooks, nested pages, 20+ system components, blockchain
                interaction for NFT/cryptos, etc.</p>
              <br>
              <div class="fill flex between align-center wrap">

                <span class="flexx">
                  <b>Login now to claim</b>
                  {{ domainCheck }}
                </span>
                <div class="r16 flexx">
                  <login class="t16 b16 update-text"></login>
                </div>
              </div>
              <div class="flex column">
                <span><b>DISCLAIMER:</b> Use at own risk! XMBL assumes no liability.</span>

                <a href="https://discord.gg/tUmfa6PAcF" target="_blank"><i class="fab fa-discord"></i> Discord for chats
                  and
                  info.</a>
                <span></span>
              </div>
            </div>

          </div>
          <div v-else>
            <div class="container fill" style="height: 75vh; max-width: 540px; overflow: scroll">
              <keep-alive>
                <component id="iform_app" :is="'iform'" relative="true" :form-model="$store.state.models.iform['app']"
                  class="sub-container fill iform_app"></component>
              </keep-alive>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div key="4" class="container flex center column flexw" style="width: 100%"
      v-else-if="$store.state.app.basics['app name']">
      <h1>{{ $store.state.app.basics["app name"] }}</h1>
      <login></login>
      <i @click="$store.dispatch('auth', { type: 'logout' })" v-if="$store.state.auth.uid" class="fas fa-unlock"></i>
    </div>

    <div class="center" style="height: 100vh" v-else>brb</div>
  </transition>
</template>

<script>
import Vue from "vue";
import VueClipboard from "vue-clipboard2";
import Vue2Filters from "vue2-filters";
import ipage from "./components/uxui/ipage.vue";

Vue.use(VueClipboard);
export default {
  components: { ipage },
  created() {
    console.log("Creating");
    if (location.href.indexOf("token=") > -1) {
      let token = location.href.split("token=")[1];
      this.$store.dispatch("auth", { type: "token", token }).then(() => {
        console.log("Auth in", this.$store.state.auth.uid);
        return this.$store.dispatch("query", {
          type: "user",
          id: this.$store.state.auth.uid,
        });
      });
    }
    this.$store.commit("setStyle");
    window.onresize = () => {
      this.$store.state.windowWidth = window.innerWidth;
      this.$store.state.windowHeight = window.innerHeight;
    };
  },
  data() {
    return {
      domainCheck: encodeURIComponent(window.location.hostname),
      maintenance: {},
      scrollVal: 0,
      secretCode: "",
      rollYourOwn: "",
      show: {
        auth: false,
        roll: false,
        maintenance: {},
      },
      siteLoading: ".",
      verify: false,
      wizard: false,
    };
  },
  methods: {
    reload() {
      window.location.reload();
    },
  },
  mixins: [Vue2Filters.mixin],
  mounted: async function () {
    for (var loading = 0; loading < 145; loading++) {
      setTimeout(() => {
        this.siteLoading = this.siteLoading.length < 5 ? this.siteLoading + "." : '.';
      }, (loading + 1) * 150);
    }

    if (window.localStorage.getItem("auth") === "null") {
      window.localStorage.removeItem("auth");
      this.$store.state.auth = {};
    }

    if (
      window.location.href.includes("&mode=signIn&lang=en") &&
      !this.$store.state.auth.uid
    ) {
      console.log("complete signup");
      this.$store.dispatch("auth", { type: "signinwithemaillink" });
    } else if (
      window.localStorage.key("auth") &&
      window.localStorage.getItem("auth") !== null
    ) {
      var auth = JSON.parse(localStorage.getItem("auth"));
      this.$store.commit("setState", {
        prop: "auth",
        val: auth,
      });
    }
  },
  name: "app",
  watch: {
    "window.innerHeight": function () {
      console.log("height change");
    },
  },
};
</script>